<template>
  <ChecklistBlockBase
    buttonsPreset="edit"
    @edit="editing = true"
    v-if="!editing"
    :style="dynamicBlockStyle"
    :buttonsData="editorMetadata.buttonsData"
    @commonAction="(action) => $emit('commonAction', action)"
  >
    <div v-html="textHtml"></div>
  </ChecklistBlockBase>
  <ChecklistBlockBase @save="onSave" buttonsPreset="save" v-else>
    <template #leftActions>
      <div class="gap-column-txs">
        <BaseIconButton
          v-for="(icon, tag) in supportedStyles"
          :key="tag"
          :icon="icon"
          @click="onStyleClicked(tag)"
          size="sm"
          :variant="block.static_text.style === tag ? 'fill' : 'ghost'"
          :hoverColor="block.static_text.style === tag ? 'background-base-inverse-primary' : 'overlay-8'"
          :textColor="block.static_text.style === tag ? 'content-base-inverse-primary' : 'content-base-primary'"
          :bgColor="block.static_text.style === tag ? 'background-base-inverse-primary' : 'content-base-primary'"
        />
      </div>
    </template>

    <BaseTextarea
      v-model="block.static_text.content"
      autoresize
      :maxlength="8192"
      placeholder="Type something"
    />
  </ChecklistBlockBase>
</template>

<script>
import ChecklistBlockBase from "./ChecklistBlockBase.vue";

export default {
  props: {
    block: Object,
    editorMetadata: Object
  },
  data() {
    return {
      editing: false,

      supportedStyles: {
        'b': 'bold',
        'i': 'italic',
        'h1': 'h1',
        'h2': 'h2'
      }
    };
  },
  methods: {
    onStyleClicked(tag) {
      if (this.block.static_text.style === tag) {
        this.$set(this.block.static_text, 'style', null);
      } else {
        this.$set(this.block.static_text, 'style', tag);
      }
    },
    onSave() {
      this.editing = false;
      this.$emit('commonAction', 'update');
    }
  },
  computed: {
    textHtml() {
      if (!this.block.static_text.content) return "";
      const breakedText = this.block.static_text.content.replace(/\n/g, "<br>");

      const classes = {
        'b': 'qrw-paragraph-md bold',
        'i': 'qrw-paragraph-md italic',
        'h1': 'qrw-heading-sm bold',
        'h2': 'qrw-label-lg bold'
      };

      return `<div class="static-text-block-content ${classes[
        this.block.static_text.style || 'qrw-paragraph-md'
      ]}">${breakedText}</div>`;
    },
    dynamicBlockStyle() {
      const paddings = {
        'h1': '40px 0px 12px 0px',
        'h2': '40px 0px 12px 0px',
      }

      return {
        'padding': paddings[this.block.static_text.style] || '12px 0px'
      }
    }
  },
  components: {
    ChecklistBlockBase,
  },
  mounted() {
    if (!this.block.static_text.content) this.editing = true;
  },
};
</script>

<style>
.static-text-block-content {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
}

.italic {
  font-style: italic;
}
</style>
